
(function () {
  // Instagram/Facebook/TikTok/etc. embedded browsers suppress window.alert(),
  // which the "I Agree to Terms" app relies on to explain a blocked checkout,
  // and its click interception misfires there even after consent is recorded.
  var IN_APP_BROWSER = /Instagram|FBAN|FB_IAB|FBAV|Line\/|MicroMessenger|TikTok|musical_ly|Snapchat|Pinterest\//i.test(navigator.userAgent);

  var MESSAGE = "Please tick the box to agree to the Reservation Agreement before checking out.";

  function findAgreeCheckbox(fromEl) {
    var scopes = [];
    var container = fromEl.closest('cart-notification-drawer, cart-drawer, .quick-buy-drawer, form, main');
    if (container) scopes.push(container);
    scopes.push(document);
    for (var i = 0; i < scopes.length; i++) {
      var boxes = scopes[i].querySelectorAll('input[type="checkbox"]');
      for (var j = 0; j < boxes.length; j++) {
        var cb = boxes[j];
        var text = '';
        if (cb.id) {
          var label = scopes[i].querySelector('label[for="' + cb.id + '"]');
          if (label) text += label.textContent;
        }
        var wrap = cb.closest('label') || cb.parentElement;
        if (wrap) text += ' ' + wrap.textContent;
        if (/agree/i.test(text)) return cb;
      }
    }
    return null;
  }

  function messageElementFor(cb) {
    var anchor = cb.closest('label') || cb.parentElement || cb;
    var existing = anchor.parentElement.querySelector('.terms-gate-error');
    if (existing) return existing;
    var el = document.createElement('p');
    el.className = 'terms-gate-error';
    el.setAttribute('role', 'alert');
    el.hidden = true;
    anchor.insertAdjacentElement('afterend', el);
    return el;
  }

  function showMessage(cb) {
    var el = messageElementFor(cb);
    el.textContent = MESSAGE;
    el.hidden = false;
    var anchor = cb.closest('label') || cb.parentElement || cb;
    if (anchor.scrollIntoView) anchor.scrollIntoView({ block: 'center', behavior: 'smooth' });
  }

  function hideMessage(cb) {
    var anchor = cb.closest('label') || cb.parentElement || cb;
    var el = anchor.parentElement && anchor.parentElement.querySelector('.terms-gate-error');
    if (el) el.hidden = true;
  }

  // Capture phase: runs before the terms app's own click handling, so the
  // suppressed-alert path can never occur. Active ONLY in in-app browsers —
  // regular browsers keep the terms app's native alert flow untouched.
  document.addEventListener('click', function (event) {
    if (!IN_APP_BROWSER) return;
    var btn = event.target && event.target.closest && event.target.closest('button[name="checkout"], input[name="checkout"], button[type="submit"], a[href="/checkout"], a[href^="/checkout?"]');
    if (!btn) return;
    var form = btn.closest('form');
    var action = (form && form.getAttribute('action')) || '';
    var isCheckout = btn.getAttribute('name') === 'checkout' ||
      /^\/checkout(\?|$)/.test(btn.getAttribute('href') || '') ||
      (/\/cart\/?$/.test(action) && btn.type === 'submit');
    if (!isCheckout) return;

    var cb = findAgreeCheckbox(btn);
    if (!cb) return; // terms app not on this page — never interfere

    if (!cb.checked) {
      event.preventDefault();
      event.stopImmediatePropagation();
      showMessage(cb);
      return;
    }

    hideMessage(cb);

    if (form) {
      // Consent was already written to the cart when the box was ticked; skip
      // every click/submit handler (the app's included) and go to checkout.
      event.preventDefault();
      event.stopImmediatePropagation();
      if (!form.querySelector('input[type="hidden"][name="checkout"]')) {
        var h = document.createElement('input');
        h.type = 'hidden';
        h.name = 'checkout';
        h.value = '';
        form.appendChild(h);
      }
      HTMLFormElement.prototype.submit.call(form);
    }
  }, true);

  document.addEventListener('change', function (event) {
    var t = event.target;
    if (t && t.type === 'checkbox' && t.checked) hideMessage(t);
  }, true);

  // Funnel telemetry (all browsers): report the first Checkout CLICK per page
  // load to the pre-order counter, so it can chart clicked -> reached ->
  // completed. Shopify's own funnel only sees clicks that successfully
  // navigate to checkout, which is exactly what a click-blocking bug hides.
  var PIXEL_ENDPOINT =
    'https://us-central1-strikeco-tennis.cloudfunctions.net/checkoutPixel';
  var clickReported = false;
  document.addEventListener('click', function (event) {
    if (clickReported) return;
    var btn = event.target && event.target.closest && event.target.closest(
      'button[name="checkout"], input[name="checkout"], a[href="/checkout"], a[href^="/checkout?"]');
    if (!btn) return;
    clickReported = true;
    try {
      fetch(PIXEL_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ kind: 'clicked', ua: navigator.userAgent }),
        keepalive: true,
      }).catch(function () {});
    } catch (e) { /* telemetry must never break checkout */ }
  }, true);
})();
